/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CkFileResp } from '../../models/ck-file-resp';

export interface ApiFileCkeditPost$Params {
}

export function apiFileCkeditPost(http: HttpClient, rootUrl: string, params?: ApiFileCkeditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CkFileResp>> {
  const rb = new RequestBuilder(rootUrl, apiFileCkeditPost.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CkFileResp>;
    })
  );
}

apiFileCkeditPost.PATH = '/api/File/ckedit';
